import Style from "./style"
import check from "./asset/check.svg"
import checked from "./asset/checked.svg"

import MainHeader from "widget/MainHeader"
import Search from "widget/Search"
import Pagenation from "widget/Pagenation"

import useGetAdminList from "entity/admin/useGetAdminList"
import usePutAdminRole from "entity/admin/usePutAdminRole"

import TStyle from "shared/style/tableStyle"
import timestampCalculator from "shared/lib/timestampCalculator"
import { ROLE_EVENT_ADMIN, ROLE_MARKETING_ADMIN, ROLE_SITE_ADMIN, ROLE_STORE_ADMIN, ROLE_SUPER_ADMIN, convertRoleAsName } from "shared/constant/lookup/role"

const AdminList = () => {

    const [adminList] = useGetAdminList()
    const [changeRole] = usePutAdminRole()

    const sizeList = ["short", "long", "long", "long", "expand", "long"]
    const tableHeadList = ["IDX", "아이디", "이름", "연락처", "권한", "가입 날짜"]

    const roleList = [
        {
            "label": "최고",
            "role_flag": ROLE_SUPER_ADMIN
        },
        {
            "label": "대회",
            "role_flag": ROLE_EVENT_ADMIN
        },
        {
            "label": "마케팅",
            "role_flag": ROLE_MARKETING_ADMIN
        },
        {
            "label": "매장",
            "role_flag": ROLE_STORE_ADMIN
        },
        {
            "label": "현장",
            "role_flag": ROLE_SITE_ADMIN
        }
    ]

    return (
        <Style.Wrapper>
            <MainHeader>관리자 계정 목록</MainHeader>
            <Search placeholder="연락처에 포함되는 글자로 검색" />

            <TStyle.TableDiv>
                <TStyle.TableRow $title>
                    {tableHeadList.map((elem, index) =>
                        <TStyle.Data $title $size={sizeList[index]}>{elem}</TStyle.Data>
                    )}
                </TStyle.TableRow>
                {adminList?.data?.admin_list?.map((elem, index) =>
                    <TStyle.TableRow $odd={index % 2 === 1}>
                        <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                        <TStyle.Data $size={sizeList[1]}>{elem?.id}</TStyle.Data>
                        <TStyle.Data $size={sizeList[2]}>{elem?.name}</TStyle.Data>
                        <TStyle.Data $size={sizeList[3]}>{elem?.contact}</TStyle.Data>
                        <TStyle.Data $size={sizeList[4]}>
                            <Style.RadioDiv>
                                {roleList.map(roleName =>
                                    <Style.Radio onClick={(e) => changeRole(e, elem?.idx, roleName.role_flag)}>
                                        <img src={convertRoleAsName[elem?.admin_role_flag] === `${roleName.label} 관리자` ? checked : check} />{roleName.label}
                                    </Style.Radio>
                                )}
                            </Style.RadioDiv>
                        </TStyle.Data>
                        <TStyle.Data $size={sizeList[5]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                    </TStyle.TableRow>
                )}
            </TStyle.TableDiv>

            <Pagenation maxPage={adminList?.data?.max_page} />
        </Style.Wrapper>
    )
}

export default AdminList